import { RefreshCw } from 'lucide-react';

import { BotaoComEspera } from '@/ui/components/botao-com-espera';
import { type EstadoCaptura } from '@fiscoai/contracts';

import { useBuscarAgora } from './use-buscar-agora';

/** Por que não dá para buscar, independente da espera da SEFAZ. */
function motivoSemBusca(estado: EstadoCaptura): string | null {
  if (estado.situacao === 'SEM_CERTIFICADO') return 'Sem certificado A1';
  if (estado.situacao === 'CERTIFICADO_VENCIDO') return 'Certificado A1 vencido';
  if (!estado.ativa || estado.situacao === 'DESLIGADA') return 'Captura desligada';
  return null;
}

/** O mais tarde entre a espera do 137 e o bloqueio 656. */
function liberacao(estado: EstadoCaptura): string | null {
  const datas = [estado.liberadaEm, estado.bloqueadaAte].filter((d): d is string => d !== null);
  if (datas.length === 0) return null;
  return datas.reduce((a, b) => (Date.parse(a) >= Date.parse(b) ? a : b));
}

/**
 * "Buscar agora" (fora da agenda): bloqueado com o motivo e a contagem enquanto a SEFAZ não libera,
 * "Buscando…" durante a busca e o toast com o que veio no fim.
 */
export function BuscarAgora({
  estado,
  tamanho = 'md',
}: {
  estado: EstadoCaptura;
  tamanho?: 'md' | 'sm';
}) {
  const busca = useBuscarAgora(estado.empresa.id, estado.fuso);
  const buscando = estado.situacao === 'EXECUTANDO' || busca.buscando;
  return (
    <BotaoComEspera
      variante="primario"
      tamanho={tamanho}
      liberadoEm={buscando ? null : liberacao(estado)}
      fuso={estado.fuso}
      motivo={buscando ? null : motivoSemBusca(estado)}
      // O selo da situação já diz por que (desligada, sem certificado).
      motivoVisivel={false}
      carregando={buscando}
      avisoLiberado="A SEFAZ liberou o CNPJ. Já pode buscar agora."
      aria-label={buscando ? 'Buscando…' : `Buscar agora as notas de ${estado.empresa.nome}`}
      onClick={busca.buscar}
    >
      {!buscando && <RefreshCw aria-hidden />}
      {buscando ? 'Buscando…' : 'Buscar agora'}
    </BotaoComEspera>
  );
}
